import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPromptTextToVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPromptTextToVideo"><Path d="M21 21H5V15H6.5V19.5H19.5V6.5H14V5H21V21Z" fill="currentColor"/><Path d="M16 13L11 16.5V9.5L16 13Z" fill="currentColor"/><Path d="M11 5.75H9.5V4.5H6.75V10.5H8V12H4V10.5H5.25V4.5H2.5V5.75H1V3H11V5.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPromptTextToVideo;
